export const FAQ_DATA = {
  member: [
    {
      category: 'Compte & Profil',
      icon: '👤',
      questions: [
        {
          q: 'Comment modifier mes informations personnelles ?',
          a: 'Accédez à "Mon Profil" dans le menu latéral, puis cliquez sur "Modifier" pour mettre à jour vos coordonnées, adresse et informations professionnelles.'
        },
        {
          q: 'Comment changer mon mot de passe ?',
          a: 'Dans votre profil, cliquez sur "Sécurité" puis "Modifier le mot de passe". Entrez votre ancien mot de passe et le nouveau deux fois.'
        },
        {
          q: 'Comment télécharger mes attestations ?',
          a: 'Rendez-vous dans "Documents", sélectionnez l\'attestation souhaitée et cliquez sur le bouton de téléchargement PDF.'
        }
      ]
    },
    {
      category: 'Souscriptions',
      icon: '📋',
      questions: [
        {
          q: 'Comment créer une nouvelle souscription ?',
          a: 'Utilisez le "Simulateur BATICO" pour calculer votre garantie, puis suivez les étapes du workflow de souscription pour finaliser.'
        },
        {
          q: 'Comment suivre l\'état de ma souscription ?',
          a: 'Dans "Mes Souscriptions", vous verrez le statut de chaque demande : En attente, Validée, ou Complétée avec tous les détails.'
        },
        {
          q: 'Puis-je modifier une souscription en cours ?',
          a: 'Les souscriptions en attente peuvent être modifiées. Contactez votre COOPER\'S pour toute modification après validation.'
        }
      ]
    },
    {
      category: 'Crédits ESS',
      icon: '💳',
      questions: [
        {
          q: 'Comment acheter des crédits ?',
          a: 'Cliquez sur "Acheter des crédits" dans votre wallet, choisissez un pack (COPPAM, O\'SCOP ou FOGEDOM) et procédez au paiement sécurisé.'
        },
        {
          q: 'Les crédits ont-ils une date d\'expiration ?',
          a: 'Les crédits ESS n\'expirent pas. Ils restent disponibles jusqu\'à leur utilisation.'
        },
        {
          q: 'Comment sont utilisés mes crédits ?',
          a: 'Les crédits sont automatiquement débités lors de certaines opérations comme la génération de documents ou certains services premium.'
        }
      ]
    }
  ],
  cooper: [
    {
      category: 'Gestion Membres',
      icon: '👥',
      questions: [
        {
          q: 'Comment ajouter un nouveau membre adhérent ?',
          a: 'Allez dans "Mes Membres adhérents", cliquez sur "Ajouter un membre" et complétez les informations entreprise. L\'auto-complétion SIRET pré-remplit raison sociale, adresse et code NAF automatiquement.'
        },
        {
          q: 'Comment lancer une simulation pour un membre ?',
          a: 'Sur la fiche du membre, ouvrez "Plus d\'actions" → "Estimation rapide" et choisissez le simulateur Cadre RCDS BATICO. Le simulateur s\'ouvre avec les données du membre pré-remplies.'
        },
        {
          q: 'Comment téléverser un justificatif (Qualibat, RGE…) ?',
          a: 'Sur la fiche du membre, "Plus d\'actions" → "Qualifications professionnelles". Téléversez le PDF — il sera notifié au Super Admin pour validation (email + cloche).'
        },
        {
          q: 'Comment suivre les souscriptions de mes membres ?',
          a: 'L\'onglet "Toutes Souscriptions" liste toutes les souscriptions RCDS / FTPE / DOS-DOMIUM de vos membres avec filtres statut, date et type de dispositif.'
        }
      ]
    },
    {
      category: 'FTPE Outremer',
      icon: '🏛️',
      questions: [
        {
          q: 'Comment inscrire un membre à la FTPE ?',
          a: 'Sur la fiche membre → "Plus d\'actions" → "Souscrire FTPE". Renseignez l\'adhésion fédération (montant, mode de paiement) — un reçu PDF officiel est généré automatiquement avec QR code de vérification.'
        },
        {
          q: 'Comment générer un Relevé d\'Information FTPE ?',
          a: 'Sur la fiche du membre adhérent FTPE → "Plus d\'actions" → "Relevé d\'information FTPE". Le PDF 2 pages premium (palette verte FTPE) est téléchargé instantanément avec QR de vérification publique.'
        }
      ]
    },
    {
      category: 'Simulateur Cadre RCDS BATICO',
      icon: '🧮',
      questions: [
        {
          q: 'Comment utiliser le simulateur BATICO ?',
          a: 'Entrez le chiffre d\'affaires du membre, ses activités sélectionnées et son effectif. Le calculateur génère automatiquement la contribution solidaire et les garanties Responsabilités civiles et décennales.'
        },
        {
          q: 'Quelle est la différence entre RCDS Annuel et Nominative ?',
          a: 'RCDS Annuel couvre l\'entreprise sur l\'année civile. RCDS Nominative est réservée aux Super Admin / Admin et cible un chantier précis. Vous voyez uniquement le mode Annuel dans votre espace COOPER\'S.'
        },
        {
          q: 'Que faire si le CA du membre dépasse le seuil ?',
          a: 'Un bandeau ambre s\'affiche dans le simulateur. La souscription bascule en arbitrage manuel — le dossier est transmis au Super Admin pour validation au cas par cas.'
        }
      ]
    },
    {
      category: 'Photos / Vidéos & Partages',
      icon: '📷',
      questions: [
        {
          q: 'Comment téléverser des photos ou vidéos pour un membre ?',
          a: 'Dans "Photos/Vidéos", glissez-déposez vos fichiers. Les vidéos > 10 Mo sont compressées automatiquement et une miniature est générée pour chaque média.'
        },
        {
          q: 'Comment recevoir un dossier ZIP partagé par un membre ?',
          a: 'L\'onglet "Partages reçus" liste tous les ZIP envoyés par vos membres. Vous recevez aussi un message dans la "Messagerie" Cooper avec le lien direct de téléchargement.'
        },
        {
          q: 'Puis-je révoquer un partage ZIP ?',
          a: 'Oui. Sur la fiche du partage, cliquez "Révoquer". Le téléchargement est immédiatement bloqué et le destinataire reçoit une notification email + in-app.'
        }
      ]
    },
    {
      category: 'Conventions & Documents',
      icon: '📄',
      questions: [
        {
          q: 'Comment consulter les conventions signées ?',
          a: '"Mes Conventions" liste vos conventions COOPER signées avec COPPAM. Vous pouvez les télécharger en PDF et voir leur date d\'échéance.'
        },
        {
          q: 'Comment imprimer un PDF officiel du tableau de bord ?',
          a: 'Cliquez sur "Imprimer PDF officiel" dans l\'en-tête de votre dashboard. Le PDF généré porte la charte institutionnelle COPPAM (logo, filets dorés, signature numérique et pagination).'
        }
      ]
    },
    {
      category: 'Crédits ESS & Demandes Publiques',
      icon: '💰',
      questions: [
        {
          q: 'Comment acheter des Demandes Publiques (crédits) ?',
          a: 'Cliquez sur "Acheter des Demandes Publiques" ou "Acheter des crédits" en haut du dashboard. Choisissez un pack et procédez au paiement sécurisé Stripe.'
        },
        {
          q: 'Comment fonctionne la recharge automatique ?',
          a: 'Selon votre formule d\'abonnement COOPER, votre portefeuille est crédité chaque mois. Consultez "Mes Crédits ESS" pour voir solde, mouvements et formule active.'
        },
        {
          q: 'Comment voir l\'historique des transactions ?',
          a: 'Dans "Mes Crédits ESS" → onglet "Historique" : toutes les transactions (crédits, débits, achats Stripe) avec dates, montants et références.'
        }
      ]
    },
    {
      category: 'Statistiques & CA',
      icon: '📊',
      questions: [
        {
          q: 'À quoi correspondent les KPI de mon dashboard ?',
          a: 'Membres = total de vos membres rattachés. Dossiers = souscriptions validées. Réussite = % de souscriptions converties. CA Total = somme des Contributions RCDS et Adhésions FTPE générées.'
        },
        {
          q: 'Pourquoi je vois "Profil COOPER en attente de configuration" ?',
          a: 'Votre compte cooper n\'a pas encore de profil COOPER lié. Cliquez sur "Compléter mon profil COOPER" et renseignez prénom, nom, structure, téléphone, territoire et SIRET.'
        }
      ]
    }
  ],
  expert: [
    {
      category: 'Expertise & Dommages',
      icon: '⚠️',
      questions: [
        {
          q: 'Comment déclarer un nouveau dommage ?',
          a: 'Dans "Mes Dommages", cliquez sur "Nouvelle déclaration", remplissez le formulaire avec les détails du sinistre et joignez les pièces justificatives.'
        },
        {
          q: 'Quels documents joindre à une déclaration ?',
          a: 'Photos du dommage, rapport d\'expertise, factures, et tout document pertinent. Les formats PDF, JPG et PNG sont acceptés.'
        }
      ]
    },
    {
      category: 'Documents & Signatures',
      icon: '✍️',
      questions: [
        {
          q: 'Comment personnaliser ma signature ?',
          a: 'Dans "Signature/Tampon", téléchargez votre signature manuscrite et votre tampon. Ils seront automatiquement appliqués aux documents.'
        },
        {
          q: 'Comment accéder aux modèles de documents ?',
          a: 'L\'onglet "Modèles Documents" contient tous les templates disponibles : rapports, attestations, conventions que vous pouvez personnaliser.'
        }
      ]
    }
  ],
  super_admin: [
    {
      category: 'Administration',
      icon: '👑',
      questions: [
        {
          q: 'Comment gérer les utilisateurs ?',
          a: 'Dans "Gestion Utilisateurs", vous pouvez créer, modifier, suspendre ou supprimer des comptes. Utilisez les filtres pour rechercher par rôle ou statut.'
        },
        {
          q: 'Comment valider une adhésion FTPE ?',
          a: 'Dans "Adhésions FTPE", les demandes en attente s\'affichent. Vérifiez les documents, puis validez ou rejetez avec un commentaire.'
        }
      ]
    },
    {
      category: 'Analytics & Rapports',
      icon: '📊',
      questions: [
        {
          q: 'Comment interpréter les statistiques ?',
          a: 'Le dashboard Analytics montre les visiteurs, pages vues et appareils. Utilisez les filtres de date pour analyser les tendances.'
        },
        {
          q: 'Comment créer une annonce ?',
          a: 'Dans "Annonces", cliquez sur "Nouvelle annonce", rédigez le message, sélectionnez les espaces cibles et définissez les dates de diffusion.'
        }
      ]
    }
  ]
};

// Vidéos tutoriels
export const VIDEOS_DATA = {
  member: [
    { id: 1, title: 'Premiers pas avec votre espace', duration: '3:45', thumbnail: '🎬', category: 'Démarrage' },
    { id: 2, title: 'Comment créer une souscription', duration: '5:20', thumbnail: '📋', category: 'Souscriptions' },
    { id: 3, title: 'Gérer vos crédits ESS', duration: '2:30', thumbnail: '💳', category: 'Crédits' },
    { id: 4, title: 'Télécharger vos documents', duration: '1:45', thumbnail: '📁', category: 'Documents' }
  ],
  cooper: [
    { id: 1, title: 'Tour de l\'espace COOPER\'S', duration: '4:00', thumbnail: '🏢', category: 'Démarrage' },
    { id: 2, title: 'Ajouter et gérer vos membres adhérents', duration: '6:15', thumbnail: '👥', category: 'Membres' },
    { id: 3, title: 'Maîtriser le simulateur Cadre RCDS BATICO', duration: '8:30', thumbnail: '🧮', category: 'Simulateurs' },
    { id: 4, title: 'Inscrire un membre à la FTPE Outremer', duration: '4:45', thumbnail: '🏛️', category: 'FTPE' },
    { id: 5, title: 'Générer un Relevé d\'information FTPE', duration: '3:30', thumbnail: '📄', category: 'Documents' },
    { id: 6, title: 'Partager des Photos/Vidéos en ZIP sécurisé', duration: '5:10', thumbnail: '📷', category: 'Médias' },
    { id: 7, title: 'Suivre vos Crédits ESS et acheter des Demandes', duration: '3:50', thumbnail: '💰', category: 'Crédits' },
    { id: 8, title: 'Téléverser un justificatif (Qualibat, RGE)', duration: '2:40', thumbnail: '🏅', category: 'Qualifications' }
  ],
  expert: [
    { id: 1, title: 'Présentation de l\'espace Expert', duration: '3:30', thumbnail: '🎯', category: 'Démarrage' },
    { id: 2, title: 'Déclarer un dommage', duration: '5:00', thumbnail: '⚠️', category: 'Dommages' },
    { id: 3, title: 'Configurer signature et tampon', duration: '2:45', thumbnail: '✍️', category: 'Signature' },
    { id: 4, title: 'Utiliser les simulateurs maîtres', duration: '7:00', thumbnail: '📐', category: 'Simulateurs' }
  ],
  super_admin: [
    { id: 1, title: 'Console d\'administration', duration: '5:00', thumbnail: '👑', category: 'Admin' },
    { id: 2, title: 'Gestion des utilisateurs', duration: '6:30', thumbnail: '👥', category: 'Utilisateurs' },
    { id: 3, title: 'Analyser les statistiques', duration: '4:15', thumbnail: '📊', category: 'Analytics' },
    { id: 4, title: 'Gérer les adhésions FTPE', duration: '5:45', thumbnail: '🏛️', category: 'FTPE' }
  ]
};
